import * as React from 'react';
import { MoreHorizontal } from 'lucide-react';
import { Button } from './button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator,
} from './dropdown-menu';
import { cn } from '../../lib/utils';

/**
 * Compact row-action menu (the "⋯" overflow). Replaces dense rows of icon
 * buttons that don't fit on mobile and look inconsistent across pages.
 */
export interface RowAction {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  destructive?: boolean;
  disabled?: boolean;
  /** Render a divider above this item. */
  separatorBefore?: boolean;
}

export function RowActions({
  actions,
  align = 'end',
  label = 'Open actions',
}: {
  actions: (RowAction | false | null | undefined)[];
  align?: 'start' | 'center' | 'end';
  label?: string;
}) {
  const items = actions.filter(Boolean) as RowAction[];
  if (items.length === 0) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={label}>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="w-44">
        {items.map((a, i) => (
          <React.Fragment key={i}>
            {a.separatorBefore && <DropdownMenuSeparator />}
            <DropdownMenuItem
              disabled={a.disabled}
              onClick={a.onClick}
              className={cn(a.destructive && 'text-destructive focus:text-destructive')}
            >
              {a.icon && <span className="mr-2 inline-flex h-4 w-4 items-center justify-center">{a.icon}</span>}
              {a.label}
            </DropdownMenuItem>
          </React.Fragment>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default RowActions;
